import { Heading2, Subtitle } from 'src/components/atoms/Typography'
import {
  FullWidthContainer,
  FullWidthContainerBackgroundColor
} from 'src/components/layouts/Container'
import { CallToActionButtonLink } from 'src/components/molecules/CallToActionButtonLink'

export interface CallToActionProps {
  heading: string
  ctaText: string
  ctaLink: string
  subtitle?: string
}

export const CallToAction = ({
  heading,
  ctaText,
  ctaLink,
  subtitle
}: CallToActionProps) => {
  return (
    <div className='py-8'>
      <Heading2 className='text-center'>{heading}</Heading2>
      <Subtitle className='text-center'>{subtitle}</Subtitle>
      <div className='flex justify-center'>
        <CallToActionButtonLink href={ctaLink}>
          {ctaText}
        </CallToActionButtonLink>
      </div>
    </div>
  )
}

export interface CallToActionSectionProps extends CallToActionProps {
  backgroundColor?: FullWidthContainerBackgroundColor
}

export const CallToActionSection = ({
  backgroundColor,
  ...props
}: CallToActionSectionProps) => {
  return (
    <FullWidthContainer backgroundColor={backgroundColor} width='narrow'>
      <CallToAction {...props} />
    </FullWidthContainer>
  )
}
